import React, { useMemo } from "react";

import { IAppMenuFlyoutProps } from "./AppMenuFlyout.types";
import { M365PulseFlyout } from "Shared/Components";
import { observer } from "mobx-react";

const AppMenuFlyoutBase = (props: IAppMenuFlyoutProps & { showFlyout: boolean }) => {
    const { showFlyout, onDismiss, menuItem } = props;

    const flyoutContent = useMemo(() => {
        if (menuItem && menuItem.flyoutContent) {
            return <menuItem.flyoutContent menuItem={menuItem} onDismiss={onDismiss} />;
        }
    }, [menuItem, onDismiss]);

    return (
        <M365PulseFlyout isOpen={showFlyout} title={menuItem?.displayName} onRequestClose={onDismiss} isLightDismiss={false}>
            {flyoutContent}
        </M365PulseFlyout>
    );
};

export const AppMenuFlyout = observer(AppMenuFlyoutBase);
